import { useCallback as l } from "react";
import { usePLMapboxLayersStore as u } from "./index.es12.js";
import { checkIsMapLoaded as c } from "./index.es245.js";
const b = () => {
  const { addLayerGroup: r } = u((e) => e.actions);
  return l(
    ({
      mapId: e,
      visible: o = !0,
      name: t,
      description: a,
      data: n,
      getColor: s,
      getLine: i,
      getWidth: d,
      onClick: p
    }) => {
      if (!c(e)) {
        console.warn(`Cannot add line layer: Map store for mapId "${e}" is not loaded yet. 
                    Make sure the PLMapbox component is properly mounted before adding layers.`);
        return;
      }
      return r({
        mapId: e,
        renderType: "static-line",
        description: a || "",
        name: t || "",
        fetchFilter: {
          data: n
        },
        visualFilter: {
          getColor: s,
          getLine: i,
          getWidth: d,
          onClick: p
        },
        visible: o,
        subLayerConfig: {}
      });
    },
    [r]
  );
};
export {
  b as useAddLineLayer
};
//# sourceMappingURL=index.es192.js.map
